import { on } from 'delegated-events'

export default class CollectionViewType {
    constructor() {
        this.cacheDom()
        this.bindEvents()
    }

    cacheDom() {
        this.currentView = document.getElementById('current-view')
    }

    bindEvents() {
        on('click', '.product-grid-action a', this.updateCurrentView.bind(this))
    }

    updateCurrentView(event) {
        event.preventDefault()
        const value = event.target.getAttribute('data-view')

        switch (value) {
            case 'grid':
                this.currentView.value = ''
                break
            case 'list':
                this.currentView.value = value
                break
        }

        events.publish('collection.filters.submit', { view: value })
    }
}
